import React from "react";
import Landing from "../components/NewComponents/Landing";
import Goals from "../components/Goals";
import Projects from "../components/NewComponents/Projects";
import Footer from "../components/Footer";
import Contact from "../components/Contact";
import About from "../components/NewComponents/About";
import Safeguarding from "../components/Safeguarding";
import LandingPage from "../components/LandingPage";

const Home = () => {
        const scrollToSection = (sectionId) => {
        const section = document.getElementById(sectionId);
        // alert(sectionId)
        if (section) {
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    return(
        <>
        {/* hello */}
            {/* <LandingPage/> */}
            <Landing onNavClick={scrollToSection}/>
            <About/>    
            <Projects/>
            {/* <Goals/>
            <Projects/>
            <About/> */}
            <Contact/>
            <Safeguarding/>
            <Footer/>
        </>
    )
}

export default Home;